import React, {Component, Fragment} from 'react'
import {observer} from 'mobx-react'

import Checkbox from 'lib/control/Checkbox'
import Error from 'lib/struct/Error'

import ShopPromoLabel from './ShopPromoLabel'
import Field from '../../struct/Field'
import Hint from '../../struct/Hint'
import DependentCheckbox from '../../control/DependentCheckbox'

import styles from './ProfileDiscountsSettings.less'

@observer export default class ProfileDiscountsSettings extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        if (context.discounts.length === 0) {
            return (
                <Field
                    label="Специальная цена"
                    fieldClass={styles['block--empty']}
                >
                    Промоакции со специальными ценами не найдены.
                    <Hint className={styles['discount-hint']}>Для работы акций типа «Специальная цена» нужно установить
                        и настроить плагин, который обеспечивает такую функциональность.</Hint>
                </Field>
            )
        }

        return (
            <Field
                label="Специальная цена"
                fieldClass={styles['block']}
            >
                {
                    context.discounts.map(shop_discount => (
                        <div key={shop_discount.id} className={styles['discount-settings-block']}>
                            <DiscountSettings
                                context={context}
                                shop_discount={shop_discount}
                            />
                        </div>
                    ))
                }
            </Field>
        )
    }
}

@observer
class DiscountSettings extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const form_state = context.form_state
        const profile = context.profile

        /** @type {ShopDiscount} */
        const shop_discount = this.props.shop_discount

        if (shop_discount.error) {
            return (
                <Checkbox
                    checked={false}
                    disabled={true}
                >
                    <ShopPromoLabel
                        label={shop_discount.name}
                        promo={shop_discount}
                    />

                    {/*<Hint className={styles['discount-hint']}>{shop_discount.hint}</Hint>*/}

                    <Error error={shop_discount.error}/>
                </Checkbox>
            )
        }

        return (
            <Fragment>
                <DependentCheckbox
                    checked={profile.isMarketDiscountEnabled(shop_discount)}
                    onChange={e => profile.toggleMarketDiscount(shop_discount, e.target.checked)}
                    state={form_state}
                >
                    <ShopPromoLabel
                        label={shop_discount.name}
                        promo={shop_discount}
                    />

                    <Hint className={styles['discount-hint']}>{shop_discount.description}</Hint>
                </DependentCheckbox>
            </Fragment>
        )
    }
}